/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCloudHealthMonitoring extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCloudHealthMonitoring");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCloudHealthMonitoring.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCloudHealthMonitoring>): BackgroundJobPayloadForPeriodicCloudHealthMonitoring {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCloudHealthMonitoring(), model);
        BackgroundJobPayloadForPeriodicCloudHealthMonitoring.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCloudHealthMonitoring>): BackgroundJobPayloadForPeriodicCloudHealthMonitoring {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCloudHealthMonitoring.newInstance(<BackgroundJobPayloadForPeriodicCloudHealthMonitoring> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCloudHealthMonitoring) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCloudHealthMonitoring.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCloudHealthMonitoring): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCloudHealthMonitoring.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
